<template>
    <div class="login-container" style="background-color: #141a48;margin: 0px;overflow: hidden;">
    <div id="canvascontainer" ref='can'></div>
    <div class="welcome"><img src="/apis/images/logo.png"></div>
    <div class = "title">道路运输从业人员继续教育平台</div>
    <el-form :model="form" status-icon :rules="rules" ref="ruleForm" class="card-box login-form">
      <el-form-item prop="user" >
        <el-input prefix-icon="el-icon-tickets" placeholder="" v-model="form.user"></el-input>
      </el-form-item>
      <el-form-item prop="password" >
        <el-input prefix-icon="el-icon-circle-check-outline" placeholder="" type="password" v-model="form.password" @keyup.enter.native="submitForm('ruleForm')"></el-input>
      </el-form-item>
      <el-form-item>
          <el-button type="primary" @click="submitForm('ruleForm')" :loading="loading">登录</el-button>
      </el-form-item>
       <el-form-item>
          <div class='copyright'><a href="https://beian.miit.gov.cn/" target="_blank">豫ICP备19023014号-1</a></div>
          <div class='copyright'>巩义市永泉汽车运输有限公司</a></div>
        </el-form-item>
    </el-form>

    </div>
</template>

<script>
  var id;
    export default {
      name: 'login',
      data() {
        return {
          form: {
            user: '',
            password: ''
          },
          rules: {
            user: [
                { required: true, message: '请输入用户名', trigger: 'blur'},
                { pattern: /^[a-zA-Z0-9_]{4,16}$/, message: '请输入4-16位（字母，数字，下划线）'}
            ],
            password: [
                { required: true, message: '请输入密码', trigger: 'blur' },
                { pattern: /^.{6,16}$/, message: '请输入6-16位密码'}
            ]
          },
          loading: false,
          showDialog: false
        }
      },


       mounted () {
        container = document.createElement( 'div' );
         this.$refs.can.appendChild( container );

        camera = new THREE.PerspectiveCamera( 75, window.innerWidth / window.innerHeight, 1, 10000 );
        camera.position.z = 1000;

        scene = new THREE.Scene();

        particles = new Array();

        var PI2 = Math.PI * 2;
        var material = new THREE.ParticleCanvasMaterial( {

          color: 0x0078de,
          program: function ( context ) {

            context.beginPath();
            context.arc( 0, 0, 1, 0, PI2, true );
            context.fill();

          }

        } );

        var i = 0;

        for ( var ix = 0; ix < AMOUNTX; ix ++ ) {

          for ( var iy = 0; iy < AMOUNTY; iy ++ ) {

            particle = particles[ i ++ ] = new THREE.Particle( material );
            particle.position.x = ix * SEPARATION - ( ( AMOUNTX * SEPARATION ) / 2 );
            particle.position.z = iy * SEPARATION - ( ( AMOUNTY * SEPARATION ) / 2 );
            scene.add( particle );

          }

        }

        renderer = new THREE.CanvasRenderer();
        renderer.setSize( window.innerWidth, window.innerHeight );
        container.appendChild( renderer.domElement );

        document.addEventListener( 'mousemove', onDocumentMouseMove, false );
        //

        window.addEventListener( 'resize', onWindowResize, false );

        animate();
       },


      methods: {
        submitForm(formName) {
          this.$refs[formName].validate((valid) => {
            if (valid) {
              this.loading = true;
              var params = new URLSearchParams();
              params.append('token', 'dqgU1wqtfzcZRAniU');
              params.append('name', this.form.user);
              params.append('password', this.form.password);
              this.$ajax.post("/apis/admin.php",params).then((ret) => {
                  this.loading = false;
                  if (ret.data.msg == true) {
                    this.$notify.success({title: '登录成功',message: '欢迎进入系统,'+ret.data.user.dw+'管理员'});
                    this.$store.commit('SET_TOKEN',ret.data.user.password);
                    this.$store.commit('SET_NAME',ret.data.user.name);
                    this.$store.commit('SET_MAX',ret.data.user.max);
                    this.$store.commit('SET_ID',ret.data.user.id);
                    this.$store.commit('SET_DW',ret.data.user.dw);
                    this.$refs['ruleForm'].resetFields();
                    cancelAnimationFrame(id);
                    this.$router.push('/home');
                  }else this.$notify.error({title: '登录失败',message: ret.data});
              }).catch(err=>{
                  console.log(err);
                  this.$notify.error({title: '登录失败',message: '网络异常'});
                  this.loading = false;
              });
            } else {
              this.loading = false;
              return false;
            }
          });
        }
      },
    }


var SEPARATION = 100, AMOUNTX = 50, AMOUNTY = 50;

var container;
var camera, scene, renderer;

var particles, particle, count = 0;

var mouseX = 0, mouseY = 0;

var windowHalfX = window.innerWidth / 2;
var windowHalfY = window.innerHeight / 2;


// animate();

function init() {



}

function onWindowResize() {

  windowHalfX = window.innerWidth / 2;
  windowHalfY = window.innerHeight / 2;

  camera.aspect = window.innerWidth / window.innerHeight;
  camera.updateProjectionMatrix();

  renderer.setSize( window.innerWidth, window.innerHeight );

}

//

function onDocumentMouseMove( event ) {

  mouseX = event.clientX - windowHalfX;
  mouseY = event.clientY - windowHalfY;

}

function onDocumentTouchStart( event ) {

  if ( event.touches.length === 1 ) {

    event.preventDefault();

    mouseX = event.touches[ 0 ].pageX - windowHalfX;
    mouseY = event.touches[ 0 ].pageY - windowHalfY;

  }

}

function onDocumentTouchMove( event ) {

  if ( event.touches.length === 1 ) {

    event.preventDefault();

    mouseX = event.touches[ 0 ].pageX - windowHalfX;
    mouseY = event.touches[ 0 ].pageY - windowHalfY;

  }

}

//

function animate() {

  id = requestAnimationFrame( animate );
  render();


}

function render() {

  camera.position.x += ( mouseX - camera.position.x ) * .05;
  camera.position.y += ( - mouseY - camera.position.y ) * .05;
  camera.lookAt( scene.position );

  var i = 0;

  for ( var ix = 0; ix < AMOUNTX; ix ++ ) {

    for ( var iy = 0; iy < AMOUNTY; iy ++ ) {

      particle = particles[ i++ ];
      particle.position.y = ( Math.sin( ( ix + count ) * 0.3 ) * 50 ) + ( Math.sin( ( iy + count ) * 0.5 ) * 50 );
      particle.scale.x = particle.scale.y = ( Math.sin( ( ix + count ) * 0.3 ) + 1 ) * 2 + ( Math.sin( ( iy + count ) * 0.5 ) + 1 ) * 2;

    }

  }

  renderer.render( scene, camera );

  count += 0.1;

}
</script>

<style>
.login-container a{color:#0078de;}
#canvascontainer{
  position: absolute;
  top: 0px;
}
.wz-input-group-prepend{
  background-color: #141a48;
   border: 1px solid #2d8cf0;
   border-right: none;
   color:  #2d8cf0;
}

.login-form .el-button{
  width: 100%
}
.login-form .el-input {
    display: inline-block;
    height: 47px;

}

.login-form .el-input__inner{
    background: transparent;
    border: 1px solid #2d8cf0;
    -webkit-appearance: none;
    border-radius: 3px;
    padding: 12px 5px 12px 30px;
    color: #eeeeee;
    height: 47px;
}

.title {
    font-size: 26px;
    font-weight: 400;
    color: #eeeeee;
    text-align: center;
    font-weight: bold;
}

.login-form {
    position: absolute;
    left: 0;
    right: 0;
    width: 300px;
    padding: 35px 35px 15px 35px;
    margin: auto;
}

.login-container {
    height: 100vh;
    background-color: #2d3a4b;
}
.welcome{
  width:100%;
  text-align: center;
}
.welcome img{
  margin:0 auto;
  width: 30%;
}
.copyright{
  width:100%;
  color: white;
  font-size: 1rem;
  text-align: center;
  z-index: 99999;
}

.copyright > a {
  color: white;
  text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// src/components/Login.vue